export const GOOGLE_USER_ROUTE_CONFIG = {
  connected: {
    route: '/google-profile/google-reviews/request',
  },
  connect: {
    route: '/google-profile/connect/get-started',
  },
  upgrade: {
    route: '/billing/plans',
  },
  agencyControlled: {
    route: '/google-profile/connect/agency-controlled',
  },
} as const;

export type GoogleConnectionStatus = keyof typeof GOOGLE_USER_ROUTE_CONFIG;
export type GooglePromptStatus = 'upgrade' | 'connect' | 'allowed';

export const getGoogleRoute = (status: GoogleConnectionStatus) => GOOGLE_USER_ROUTE_CONFIG[status].route;
